import { render, staticRenderFns } from "./GridProperties.vue?vue&type=template&id=62e797a4&scoped=true"
import script from "./GridProperties.vue?vue&type=script&setup=true&lang=ts"
export * from "./GridProperties.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GridProperties.vue?vue&type=style&index=0&id=62e797a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e797a4",
  null
  
)

export default component.exports